/* ================= Helpers ================= */
const fmtCents = (cents) => "$" + (cents / 100).toLocaleString("en-US", { maximumFractionDigits: 0 });
const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/* ================= Cart (Shopify Ajax Cart API) ================= */
const cartDrawer = document.getElementById("cartDrawer");
const cartBackdrop = document.getElementById("cartBackdrop");
const cartItemsEl = document.getElementById("cartItems");
const cartEmpty = document.getElementById("cartEmpty");
const cartFoot = document.getElementById("cartFoot");
const cartTotal = document.getElementById("cartTotal");
const cartCount = document.getElementById("cartCount");

async function fetchCart() {
  const res = await fetch("/cart.js");
  return res.json();
}

function deckPicks(item) {
  return Object.entries(item.properties || {})
    .filter(([k, v]) => /^Deck \d+$/.test(k) && v)
    .sort((a, b) => parseInt(a[0].slice(5), 10) - parseInt(b[0].slice(5), 10))
    .map(([, v]) => v);
}
function cartLineTitle(item) {
  const size = item.variant_title || item.variant_options?.[0] || "";
  const picks = deckPicks(item);
  const mixed = picks.length > 1 && new Set(picks).size > 1;
  return mixed ? `Mixed Set of ${picks.length}` : `${item.product_title} &mdash; Set of ${size}`;
}
function designRowHTML(item) {
  const picks = deckPicks(item);
  if (picks.length < 2) return "";
  return `<ul class="cart-item__designs">${picks
    .map((d, i) => `<li data-design="${d}"><img alt="" src=""><span>${i + 1}. ${d}</span></li>`)
    .join("")}</ul>`;
}
async function hydrateDesignSwatches(root) {
  const lis = root.querySelectorAll(".cart-item__designs li");
  if (!lis.length) return;
  const catalog = await loadUpsellCatalog();
  lis.forEach((li) => {
    const img = li.querySelector("img");
    const p = catalog?.find((x) => x.title === li.dataset.design);
    const src = p?.images?.[0]?.src;
    if (img && src) img.src = src + (src.includes("?") ? "&" : "?") + "width=80";
    else img?.remove();
  });
}

function renderCart(cart) {
  cartCount.textContent = cart.item_count;
  cartItemsEl.innerHTML = "";
  const isEmpty = cart.item_count === 0;
  cartEmpty.style.display = isEmpty ? "" : "none";
  cartFoot.hidden = isEmpty;
  renderUpsell(cart);
  if (isEmpty) return;

  cart.items.forEach((item) => {
    const el = document.createElement("div");
    el.className = "cart-item";
    el.innerHTML = `
      <img class="cart-item__img" src="${item.image || ""}" alt="">
      <div class="cart-item__body">
        <p class="cart-item__title">${cartLineTitle(item)}</p>
        ${designRowHTML(item)}
        ${(() => {
          const props = Object.entries(item.properties || {}).filter(([k, v]) => !k.startsWith("_") && !/^Deck \d+$/.test(k) && v);
          return props.length ? `<p class="cart-item__meta">${props.map(([k, v]) => `${k}: ${v}`).join(" &middot; ")}</p>` : "";
        })()}
        <div class="cart-item__row">
          <span class="cart-item__price">${item.quantity} &times; ${fmtCents(item.price)}</span>
          <button class="cart-item__remove" data-key="${item.key}">Remove</button>
        </div>
      </div>`;
    cartItemsEl.appendChild(el);
  });
  cartTotal.textContent = fmtCents(cart.total_price);
  hydrateDesignSwatches(cartItemsEl);
}

async function refreshCart() {
  const cart = await fetchCart();
  renderCart(cart);
  return cart;
}

cartItemsEl.addEventListener("click", async (e) => {
  const btn = e.target.closest(".cart-item__remove");
  if (!btn) return;
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: btn.dataset.key, quantity: 0 }),
  });
  refreshCart();
});

/* ---- "Complete the wall" cross-sell ---- */
const cartUpsell = document.getElementById("cartUpsell");
const cartUpsellRow = document.getElementById("cartUpsellRow");
let upsellCatalog = null;

async function loadUpsellCatalog() {
  if (upsellCatalog) return upsellCatalog;
  try {
    const res = await fetch("/collections/deck-wall-art/products.json?limit=20");
    if (!res.ok) return null;
    const data = await res.json();
    upsellCatalog = (data.products || []).filter((p) => p.images?.length && p.variants?.length);
  } catch {
    upsellCatalog = null;
  }
  return upsellCatalog;
}

async function renderUpsell(cart) {
  if (!cartUpsell) return;
  if (cart.item_count === 0) {
    cartUpsell.hidden = true;
    return;
  }
  const catalog = await loadUpsellCatalog();
  if (!catalog) {
    cartUpsell.hidden = true;
    return;
  }
  const inCart = new Set(cart.items.map((item) => item.handle));
  const picks = catalog.filter((p) => !inCart.has(p.handle)).slice(0, 3);
  if (!picks.length) {
    cartUpsell.hidden = true;
    return;
  }
  cartUpsellRow.innerHTML = "";
  picks.forEach((p) => {
    const variant = p.variants[0];
    const img = p.images[0].src + (p.images[0].src.includes("?") ? "&" : "?") + "width=160";
    const el = document.createElement("div");
    el.className = "upsell-card";
    el.innerHTML = `
      <img class="upsell-card__img" src="${img}" alt="" loading="lazy">
      <p class="upsell-card__title">${p.title}</p>
      <button class="upsell-card__add" data-upsell-variant="${variant.id}">Add &middot; $${Math.round(parseFloat(variant.price))}</button>`;
    cartUpsellRow.appendChild(el);
  });
  cartUpsell.hidden = false;
}

cartUpsellRow?.addEventListener("click", async (e) => {
  const btn = e.target.closest("[data-upsell-variant]");
  if (!btn) return;
  btn.disabled = true;
  await addVariantToCart(btn.dataset.upsellVariant, 1);
});

/* ================= Lifestyle strip — drag to scroll ================= */
(function initStripDrag() {
  const strip = document.getElementById("stripGrid");
  if (!strip) return;
  const arrow = document.getElementById("stripArrow");
  if (arrow) {
    const updateArrow = () => {
      const atEnd = strip.scrollLeft >= strip.scrollWidth - strip.clientWidth - 40;
      arrow.classList.toggle("is-hidden", atEnd);
    };
    arrow.addEventListener("click", () => {
      strip.scrollBy({ left: strip.clientWidth * 0.75, behavior: "smooth" });
    });
    strip.addEventListener("scroll", updateArrow, { passive: true });
    updateArrow();
  }
  let isDown = false;
  let startX = 0;
  let startScroll = 0;
  strip.addEventListener("pointerdown", (e) => {
    isDown = true;
    startX = e.clientX;
    startScroll = strip.scrollLeft;
    strip.classList.add("is-dragging");
  });
  window.addEventListener("pointermove", (e) => {
    if (!isDown) return;
    strip.scrollLeft = startScroll - (e.clientX - startX);
  });
  window.addEventListener("pointerup", () => {
    isDown = false;
    strip.classList.remove("is-dragging");
  });
  strip.addEventListener("dragstart", (e) => e.preventDefault());
})();

/* ================= Policy pages — auto-link emails, phones, addresses ================= */
(function initPolicyLinks() {
  const body = document.querySelector(".shopify-policy__body .rte");
  if (!body) return;
  const EMAIL = /[\w.+-]+@[\w-]+(?:\.[\w-]+)+/g;
  const PHONE = /(?:\+?1[\s.-]?)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}/g;
  const ADDRESS = /\d{1,6}\s+[A-Za-z0-9 .#'-]+?(?:,\s*[A-Za-z0-9 .#'-]+?)*,\s*[A-Za-z .]+?\s+[A-Z]{2}\s+\d{5}(?:-\d{4})?(?:,\s*(?:United States|USA|US))?/g;

  // Paragraphs that are nothing but a bold phrase are section headings in
  // Shopify's policy templates — promote them so they read as headings.
  body.querySelectorAll("p").forEach((p) => {
    const strong = p.querySelector("strong, b");
    if (strong && p.textContent.trim() === strong.textContent.trim() && strong.textContent.trim().length < 90) {
      p.classList.add("is-heading");
    }
  });

  const found = { email: null, phone: null, address: null };
  const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  let node;
  while ((node = walker.nextNode())) {
    if (node.nodeValue.trim() && !node.parentElement.closest("a")) textNodes.push(node);
  }
  textNodes.forEach((textNode) => {
    const text = textNode.nodeValue;
    const matches = [];
    for (const [type, re] of [["email", EMAIL], ["phone", PHONE], ["address", ADDRESS]]) {
      re.lastIndex = 0;
      let m;
      while ((m = re.exec(text))) matches.push({ type, start: m.index, end: m.index + m[0].length, value: m[0] });
    }
    if (!matches.length) return;
    // drop overlaps (address may contain digits that look like a phone)
    matches.sort((a, b) => a.start - b.start || b.end - a.end);
    const kept = [];
    let cursor = 0;
    matches.forEach((m) => { if (m.start >= cursor) { kept.push(m); cursor = m.end; } });
    const frag = document.createDocumentFragment();
    let pos = 0;
    kept.forEach((m) => {
      if (m.start > pos) frag.appendChild(document.createTextNode(text.slice(pos, m.start)));
      const a = document.createElement("a");
      const v = m.value.trim();
      if (m.type === "email") a.href = "mailto:" + v;
      else if (m.type === "phone") a.href = "tel:" + v.replace(/[^\d+]/g, "");
      else { a.href = "https://maps.google.com/?q=" + encodeURIComponent(v); a.target = "_blank"; a.rel = "noopener"; }
      a.textContent = m.value;
      if (!found[m.type]) found[m.type] = { value: v, href: a.href };
      frag.appendChild(a);
      pos = m.end;
    });
    if (pos < text.length) frag.appendChild(document.createTextNode(text.slice(pos)));
    textNode.parentNode.replaceChild(frag, textNode);
  });

  // Contact-information page: add tappable cards above the plain text
  if (location.pathname.endsWith("/contact-information") && (found.email || found.phone || found.address)) {
    const cards = document.createElement("div");
    cards.className = "policy-contact";
    const card = (label, item) => item ? `<div class="policy-contact__card"><span>${label}</span><a href="${item.href}"${label === "Address" ? ' target="_blank" rel="noopener"' : ""}>${item.value}</a></div>` : "";
    cards.innerHTML = card("Email", found.email) + card("Phone", found.phone) + card("Address", found.address);
    body.insertBefore(cards, body.firstChild);
  }
})();

function openCart() {
  cartDrawer.hidden = false;
  cartBackdrop.hidden = false;
  document.body.style.overflow = "hidden";
}
function closeCart() {
  cartDrawer.hidden = true;
  cartBackdrop.hidden = true;
  document.body.style.overflow = "";
}

document.getElementById("cartBtn").addEventListener("click", () => {
  refreshCart();
  openCart();
});
document.getElementById("cartClose").addEventListener("click", closeCart);
cartBackdrop.addEventListener("click", closeCart);
document.getElementById("cartShopLink").addEventListener("click", closeCart);
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && !cartDrawer.hidden) closeCart();
});

async function addVariantToCart(variantId, quantity, properties) {
  const payload = { id: variantId, quantity };
  if (properties && Object.keys(properties).length) payload.properties = properties;
  const res = await fetch(window.themeRoutes.cartAdd, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    showToast(err.description || "Couldn't add that to your cart.");
    return false;
  }
  await refreshCart();
  showToast("Added to cart ✓");
  openCart();
  return true;
}

/* ================= Product forms (gallery + variant chips + qty) ================= */
function initProductForms() {
  document.querySelectorAll("[data-product-form]").forEach((form) => {
    let qty = 1;
    const qtyValue = form.querySelector("[data-qty-value]");
    const priceEl = form.querySelector("[data-price]");
    const priceNoteEl = form.querySelector("[data-price-note]");
    const setLabelEl = form.querySelector("[data-set-label]");
    const addPriceEl = form.querySelector("[data-add-price]");
    const addBtn = form.querySelector("[data-add-to-cart]");
    const picker = form.querySelector("[data-variant-picker]");

    function activeChip() {
      return picker.querySelector(".chip.is-active") || picker.querySelector(".chip");
    }

    function updatePrice() {
      const chip = activeChip();
      if (!chip) return;
      const price = chip.dataset.price;
      priceEl.textContent = price;
      if (addPriceEl) addPriceEl.textContent = price;
      if (setLabelEl) {
        const size = chip.dataset.perDeck;
        setLabelEl.textContent = `— ${size} deck${size > 1 ? "s" : ""}`;
      }
      if (priceNoteEl) priceNoteEl.textContent = "";
    }

    if (picker) {
      picker.addEventListener("click", (e) => {
        const chip = e.target.closest(".chip");
        if (!chip || chip.disabled) return;
        picker.querySelectorAll(".chip").forEach((c) => c.classList.remove("is-active"));
        chip.classList.add("is-active");
        updatePrice();
        const available = !chip.disabled;
        addBtn.disabled = !available;
        addBtn.innerHTML = available
          ? `Add to Cart &mdash; <span data-add-price>${chip.dataset.price}</span>`
          : "Sold Out";
      });
    }

    const qtyMinus = form.querySelector("[data-qty-minus]");
    const qtyPlus = form.querySelector("[data-qty-plus]");
    if (qtyPlus) qtyPlus.addEventListener("click", () => { qty = Math.min(qty + 1, 10); qtyValue.textContent = qty; });
    if (qtyMinus) qtyMinus.addEventListener("click", () => { qty = Math.max(qty - 1, 1); qtyValue.textContent = qty; });

    const galleryMain = form.querySelector("[data-gallery-main] [data-gallery-image]");
    const thumbsWrap = form.querySelector(".gallery__thumbs");
    if (thumbsWrap) {
      thumbsWrap.addEventListener("click", (e) => {
        const thumb = e.target.closest(".thumb");
        if (!thumb) return;
        thumbsWrap.querySelectorAll(".thumb").forEach((t) => t.classList.remove("is-active"));
        thumb.classList.add("is-active");
        if (galleryMain) galleryMain.src = thumb.dataset.src;
      });
    }

    /* Design picker — swaps the whole form to another product in place */
    const designPicker = form.querySelector("[data-design-picker]");
    if (designPicker) {
      designPicker.addEventListener("click", async (e) => {
        const designBtn = e.target.closest(".design");
        if (!designBtn || designBtn.classList.contains("is-active")) return;
        try {
          const res = await fetch(`/products/${designBtn.dataset.handle}.js`);
          if (!res.ok) return;
          const p = await res.json();

          designPicker.querySelectorAll(".design").forEach((d) => d.classList.remove("is-active"));
          designBtn.classList.add("is-active");

          const titleEl = form.querySelector(".product__title .mask__inner") || form.querySelector(".product__title");
          if (titleEl) titleEl.textContent = p.title;
          const sized = (src, w) => src + (src.includes("?") ? "&" : "?") + "width=" + w;
          if (galleryMain && p.featured_image) galleryMain.src = sized(p.featured_image, 1200);
          if (thumbsWrap) {
            const images = p.images || [];
            thumbsWrap.innerHTML = "";
            thumbsWrap.hidden = images.length < 2;
            images.forEach((src, i) => {
              const btn = document.createElement("button");
              btn.className = "thumb" + (i === 0 ? " is-active" : "");
              btn.dataset.src = sized(src, 1200);
              btn.setAttribute("aria-label", "View image " + (i + 1));
              btn.innerHTML = `<img src="${sized(src, 160)}" alt="" loading="lazy">`;
              thumbsWrap.appendChild(btn);
            });
          }

          const chips = picker.querySelectorAll(".chip");
          p.variants.forEach((v, i) => {
            const chip = chips[i];
            if (!chip) return;
            chip.dataset.variantId = v.id;
            chip.dataset.price = fmtCents(v.price);
            chip.dataset.perDeck = v.option1;
            chip.disabled = !v.available;
            chip.classList.toggle("is-soldout", !v.available);
            const small = chip.querySelector("small");
            if (small) small.textContent = fmtCents(v.price);
          });

          const active = picker.querySelector(".chip.is-active") || chips[0];
          if (active) {
            updatePrice();
            addBtn.disabled = active.disabled;
            addBtn.innerHTML = active.disabled
              ? "Sold Out"
              : `Add to Cart &mdash; <span data-add-price>${active.dataset.price}</span>`;
          }

          const buybarT = document.getElementById("buybarTitle");
          const buybarI = document.getElementById("buybarImg");
          if (buybarT) buybarT.textContent = p.title;
          if (buybarI && p.featured_image) buybarI.src = p.featured_image;
          const buybarM = document.getElementById("buybarMeta");
          const activeNow = picker.querySelector(".chip.is-active") || chips[0];
          if (buybarM && activeNow) buybarM.textContent = `Set of ${activeNow.dataset.perDeck} · ${activeNow.dataset.price}`;
        } catch (err) {
          showToast("Couldn't load that design — try again.");
        }
      });
    }

    /* Set builder — pick a different design for each deck in a multi-deck set.
       The set-size variant carries the price; chosen designs ride along as
       line-item properties so they show in the cart, checkout and the order. */
    const setBuilder = form.querySelector("[data-set-builder]");
    const setSlots = form.querySelector("[data-set-slots]");
    function designList() {
      const btns = [...form.querySelectorAll("[data-design-picker] .design")];
      if (btns.length) {
        return btns.map((b) => ({
          handle: b.dataset.handle,
          title: b.textContent.trim(),
          swatch: b.querySelector("img")?.src || "",
        }));
      }
      const title = form.querySelector(".product__title")?.textContent.trim() || "";
      return [{ handle: "", title, swatch: galleryMain?.src || "" }];
    }
    function currentDesignTitle() {
      const active = form.querySelector("[data-design-picker] .design.is-active");
      return active ? active.textContent.trim() : form.querySelector(".product__title")?.textContent.trim();
    }
    function renderSlots() {
      if (!setBuilder || !setSlots) return;
      const chip = activeChip();
      const n = chip ? parseInt(chip.dataset.perDeck, 10) : 1;
      if (!n || n < 2) {
        setBuilder.hidden = true;
        setSlots.innerHTML = "";
        return;
      }
      const designs = designList();
      const current = currentDesignTitle();
      const previous = [...setSlots.querySelectorAll("select")].map((s) => s.value);
      setSlots.innerHTML = "";
      for (let i = 0; i < n; i++) {
        const value = previous[i] && designs.some((d) => d.title === previous[i]) ? previous[i] : current;
        const swatch = designs.find((d) => d.title === value)?.swatch || "";
        const slot = document.createElement("label");
        slot.className = "setb__slot";
        slot.innerHTML = `
          <img class="setb__swatch" src="${swatch}" alt="">
          <span class="setb__num">Deck ${i + 1}</span>
          <select class="setb__select" data-slot="${i + 1}" aria-label="Design for deck ${i + 1}">
            ${designs.map((d) => `<option value="${d.title}"${d.title === value ? " selected" : ""}>${d.title}</option>`).join("")}
          </select>`;
        setSlots.appendChild(slot);
      }
      setBuilder.hidden = false;
    }
    if (setSlots) {
      setSlots.addEventListener("change", (e) => {
        const select = e.target.closest("select");
        if (!select) return;
        const d = designList().find((x) => x.title === select.value);
        const img = select.closest(".setb__slot")?.querySelector(".setb__swatch");
        if (img && d) img.src = d.swatch;
      });
    }
    function collectSetProperties() {
      if (!setBuilder || setBuilder.hidden) return null;
      const props = {};
      setSlots.querySelectorAll("select").forEach((s) => { props[`Deck ${s.dataset.slot}`] = s.value; });
      return props;
    }
    form.collectSetProperties = collectSetProperties;
    if (picker) picker.addEventListener("click", (e) => { if (e.target.closest(".chip")) renderSlots(); });
    if (designPicker) {
      designPicker.addEventListener("click", () => {
        // wait for the async swap to update the active design, then reset slots to it
        setTimeout(() => { if (setSlots) setSlots.innerHTML = ""; renderSlots(); }, 700);
      });
    }
    renderSlots();

    if (addBtn) {
      addBtn.addEventListener("click", async () => {
        const chip = activeChip();
        const variantId = chip ? chip.dataset.variantId : form.dataset.productId;
        addBtn.disabled = true;
        await addVariantToCart(variantId, qty, collectSetProperties());
        addBtn.disabled = false;
      });
    }

    updatePrice();
  });
}

/* ================= Sticky buy bar ================= */
const buybar = document.getElementById("buybar");
const buybarMeta = document.getElementById("buybarMeta");
const buybarTitle = document.getElementById("buybarTitle");
const buybarImg = document.getElementById("buybarImg");
const shopSection = document.getElementById("shop");
if (buybar && shopSection) {
  const buybarObserver = new IntersectionObserver(
    ([entry]) => {
      const below = entry.boundingClientRect.bottom < 0;
      buybar.hidden = entry.isIntersecting || !below;
    },
    { threshold: 0 }
  );
  buybarObserver.observe(shopSection);

  document.getElementById("buybarAdd").addEventListener("click", async () => {
    const form = shopSection.querySelector("[data-product-form]");
    if (!form) return;
    const chip = form.querySelector(".chip.is-active") || form.querySelector(".chip");
    if (!chip) return;
    await addVariantToCart(chip.dataset.variantId, 1, form.collectSetProperties ? form.collectSetProperties() : null);
  });

  const shopForm = shopSection.querySelector("[data-product-form]");
  if (shopForm) {
    const title = shopSection.querySelector(".product__title");
    const img = shopSection.querySelector("[data-gallery-image]");
    if (title && buybarTitle) buybarTitle.textContent = title.textContent.trim();
    if (img && buybarImg) buybarImg.src = img.src;
    const syncBuybarMeta = () => {
      const chip = shopForm.querySelector(".chip.is-active") || shopForm.querySelector(".chip");
      if (chip && buybarMeta) buybarMeta.textContent = `Set of ${chip.dataset.perDeck} · ${chip.dataset.price}`;
    };
    shopForm.addEventListener("click", (e) => {
      if (e.target.closest(".chip")) setTimeout(syncBuybarMeta, 0);
    });
    syncBuybarMeta();
  }
}

/* ================= 3D collection rail ================= */
const rail = document.getElementById("rail");
if (rail) {
  const railCards = [...rail.querySelectorAll(".rail-card")];
  const railProgress = document.getElementById("railProgress");

  function updateRail3D() {
    const railRect = rail.getBoundingClientRect();
    const centerX = railRect.left + railRect.width / 2;
    railCards.forEach((card) => {
      const r = card.getBoundingClientRect();
      const cardCenter = r.left + r.width / 2;
      const t = Math.max(-1, Math.min(1, (cardCenter - centerX) / (railRect.width / 2)));
      const frame = card.querySelector(".rail-card__frame");
      if (reducedMotion) {
        frame.style.transform = "none";
        card.style.opacity = 1;
      } else {
        const rotate = t * -32;
        const depth = (1 - Math.abs(t)) * 70;
        const scale = 0.86 + (1 - Math.abs(t)) * 0.14;
        frame.style.transform = `translateZ(${depth}px) rotateY(${rotate}deg) scale(${scale})`;
        card.style.opacity = 0.45 + (1 - Math.abs(t)) * 0.55;
      }
    });
    const max = rail.scrollWidth - rail.clientWidth;
    if (railProgress && max > 0) {
      const frac = rail.scrollLeft / max;
      const spanW = railProgress.offsetWidth || 1;
      const trackW = railProgress.parentElement.offsetWidth;
      railProgress.style.left = frac * (trackW - spanW) + "px";
    }
  }
  rail.addEventListener("scroll", () => requestAnimationFrame(updateRail3D), { passive: true });
  window.addEventListener("resize", updateRail3D);

  let isDown = false, startX = 0, startScroll = 0;
  rail.addEventListener("pointerdown", (e) => {
    isDown = true;
    startX = e.clientX;
    startScroll = rail.scrollLeft;
    rail.classList.add("is-dragging");
  });
  window.addEventListener("pointermove", (e) => {
    if (!isDown) return;
    rail.scrollLeft = startScroll - (e.clientX - startX);
  });
  window.addEventListener("pointerup", () => {
    isDown = false;
    rail.classList.remove("is-dragging");
  });

  function centerRail() {
    rail.scrollLeft = (rail.scrollWidth - rail.clientWidth) / 2;
    updateRail3D();
  }
  centerRail();
  window.addEventListener("load", centerRail);
}

/* ================= Toast ================= */
const toast = document.getElementById("toast");
let toastTimer;
function showToast(msg) {
  toast.textContent = msg;
  toast.hidden = false;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => (toast.hidden = true), 2600);
}

/* ================= Hero: cinematic spin loop ================= */
const heroSpin = document.querySelector(".hero__spin");
if (heroSpin) {
  if (reducedMotion) {
    heroSpin.removeAttribute("autoplay");
    heroSpin.pause();
  } else {
    const tryPlay = () => { if (heroSpin.paused) heroSpin.play().catch(() => {}); };
    tryPlay();
    window.addEventListener("load", tryPlay);
    document.addEventListener("visibilitychange", () => { if (!document.hidden) tryPlay(); });
    window.addEventListener("pointerdown", tryPlay, { once: true });
  }
}

/* ================= Motion: masked & fade reveals ================= */
const maskParents = new Set();
document.querySelectorAll(".mask").forEach((m) => maskParents.add(m.parentElement));

const revealables = [
  ...maskParents,
  ...document.querySelectorAll(".reveal-fade, .reveal-img"),
];

const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("in");
        revealObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.15, rootMargin: "0px 0px -6% 0px" }
);
revealables.forEach((el) => revealObserver.observe(el));

/* ================= Motion: parallax ================= */
const parallaxEls = [...document.querySelectorAll("[data-parallax]")];
if (!reducedMotion && parallaxEls.length) {
  let ticking = false;
  const applyParallax = () => {
    parallaxEls.forEach((el) => {
      const speed = parseFloat(el.dataset.parallax) || 0.1;
      const rect = el.parentElement.getBoundingClientRect();
      const offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * speed;
      el.style.transform = `translateY(${offset}px)`;
    });
    ticking = false;
  };
  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(applyParallax);
      }
    },
    { passive: true }
  );
  applyParallax();
}

/* ================= Motion: custom cursor ================= */
const cursor = document.getElementById("cursor");
const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
if (cursor && finePointer && !reducedMotion) {
  let cx = -100, cy = -100, tx = -100, ty = -100;
  let cursorSeen = false;
  document.addEventListener("mousemove", (e) => {
    tx = e.clientX;
    ty = e.clientY;
    if (!cursorSeen) {
      cursorSeen = true;
      cx = tx; cy = ty;
      cursor.style.opacity = "0.9";
    }
  });
  document.addEventListener("mouseleave", () => {
    cursor.style.opacity = "0";
    cursorSeen = false;
  });
  const lerp = (a, b, n) => a + (b - a) * n;
  (function cursorLoop() {
    cx = lerp(cx, tx, 0.18);
    cy = lerp(cy, ty, 0.18);
    cursor.style.transform = `translate(${cx - 0}px, ${cy - 0}px) translate(-50%, -50%)`;
    requestAnimationFrame(cursorLoop);
  })();
  const hoverables = "a, button, summary, .thumb, .rail";
  document.addEventListener("mouseover", (e) => {
    if (e.target.closest(hoverables)) cursor.classList.add("is-active");
  });
  document.addEventListener("mouseout", (e) => {
    if (e.target.closest(hoverables)) cursor.classList.remove("is-active");
  });
}

/* ================= Init ================= */
initProductForms();
refreshCart();
